import { ErrorMessage, Field, Form } from 'vee-validate';
import { computed, ref } from "vue";
import { ReturnFieldComponent, ReturnSelectComponent } from './returns-common.mjs';

const ReturnsWizardItemSelectionComponent = {
	props: {
		items: Array,
		returnReasons: Array,
	},
	emits: [
		'itemsConfirmed',
	],
	setup( props, { emit } ) {

		const cloneItem = item => ( { ...item } );
		const items = ref( props.items.map( cloneItem ) );

		const validSelection = computed( () => {
			const currentSelection = items.value.filter( item => item.selected );
			return currentSelection.length > 0 && currentSelection.every( item => item.reason.trim().length > 0 );
		} );

		const atLeastOneItemSelected = () => {
			const itemsSelected = items.value.filter( item => item.selected ).length;
			if ( itemsSelected === 0 )
				return 'Selezionare almeno un articolo da restituire.';
			return true;
		};

		const confirmSelection = () => emit( 'itemsConfirmed', items );

		return {
			items,
			validSelection,
			atLeastOneItemSelected, // DEPRECATED
			confirmSelection,
		}
	},
	template: `
		<Form v-slot="{ meta }" @submit="confirmSelection">
			<div class="wizard-step-body">
				<div class="form" :class="{ valid: meta.valid, invalid: !meta.valid }">
					<Field type="checkbox" name="items" v-slot="{ field, meta, values }" v-model="items" :rules="atLeastOneItemSelected">
						<div class="w-full" :class="meta">
							<fieldset class="fieldset w-full text-left">
								<legend class="px-2 bg-white">Articoli rendibili:</legend>
								<div style="display:grid;grid-template-columns:20px 100px 1fr;column-gap:1rem;row-gap:2rem;align-items:center">
									<template v-for="( item, index ) in items">
										<input type="checkbox" v-model="item.selected" class="check" />
										<div class="product-image-container">
											<img :src="item.imageSrc" class="w-full" width="100" height="100" />
										</div>
										<div class="flex flex-col gap-4">
											<div class="flex flex-row gap-2">
												<div class="flex-grow">{{ item.name }}</div>
											</div>
											<ReturnSelectComponent v-if="item.selected" v-model="item.reason" :name="'reason-' + index" rules="required" label="Motivazione" :small="true" :options="returnReasons" />
										</div>
									</template>
								</div>
							</fieldset>
							<ErrorMessage name="items" class="error-message" />
						</div>
					</field>
				</div>
			</div>
			<div class="wizard-step-footer">
				<button type="submit" class="button button--primary">
					Conferma selezione
				</button>
			</div>
		</Form>
	`,
	components: {
		Form,
		Field,
		ReturnSelectComponent,
		ErrorMessage,
	}
}

/**
<div class="wizard-step-body">
	<div style="display:grid;grid-template-columns:20px 80px 1fr;column-gap:1rem;row-gap:2rem;" class="items-center text-left">
		<template v-for="item in items">
			<input type="checkbox" v-model="item.selected" />
			<div class="product-image-container">
				<img :src="item.imageSrc" class="w-full" width="80" height="80" />
			</div>
			<div class="flex flex-col gap-2">
				<div class="flex flex-row gap-2">
					<div class="flex-grow">{{ item.name }}</div>
					<!-- <div>{{ item.price.toFixed(2) }} €</div> -->
				</div>
				<input v-if="item.selected" type="text" required v-model="item.reason" placeholder="Motivazione" />
			</div>
		</template>
	</div>
</div>
**/

export default ReturnsWizardItemSelectionComponent;
